"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = Avatar;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const types_1 = require("@src/types");
const streamline_icon_single_man_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-single-man.svg"));
const streamline_icon_single_woman_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-single-woman.svg"));
const streamline_icon_single_neutral_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-single-neutral.svg"));
const streamline_icon_buildings_1_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-buildings-1.svg"));
const styled_components_1 = require("styled-components");
const Avatar_style_1 = require("./Avatar.style");
function getFallbackAvatarIcon({ account, color }) {
    if ((account === null || account === void 0 ? void 0 : account.accountTypeId) === types_1.AccountType.candidate) {
        switch (account.sex) {
            case types_1.AccountSex.man:
                return (0, jsx_runtime_1.jsx)(streamline_icon_single_man_svg_1.default, { fill: color });
            case types_1.AccountSex.woman:
                return (0, jsx_runtime_1.jsx)(streamline_icon_single_woman_svg_1.default, { fill: color });
            default:
                return (0, jsx_runtime_1.jsx)(streamline_icon_single_neutral_svg_1.default, { fill: color });
        }
    }
    if ((account === null || account === void 0 ? void 0 : account.accountTypeId) === types_1.AccountType.company) {
        return (0, jsx_runtime_1.jsx)(streamline_icon_buildings_1_svg_1.default, { fill: color });
    }
    return (0, jsx_runtime_1.jsx)(streamline_icon_single_neutral_svg_1.default, { fill: color });
}
function Avatar(props) {
    const theme = (0, styled_components_1.useTheme)();
    const { className, src, color = theme.color.gray4, account, size = 'large', shape = 'circle', contain = undefined, ...otherProps } = props;
    return ((0, jsx_runtime_1.jsx)(Avatar_style_1.Avatar, { src: src, size: size, shape: shape, className: className, "$contain": contain, icon: getFallbackAvatarIcon({ account, color }), ...otherProps }));
}
